$shm_projects_codex_chat $shm_hitalama_project_codex
	sessions_page_visible true
	Sessions_actions $mol_pick
		hint \Действия с сессиями проекта
		align \bottom_right
		trigger_content / <= Sessions_actions_icon $mol_icon_dots_vertical
		bubble_content / <= Unpin_all $mol_button_minor
			title \Открепить все
			enabled <= sessions_unpin_enabled
			click? <=> sessions_unpin? null
	Sessions_memory $mol_labeler
		title \Память Codex
		Content <= Sessions_memory_value $mol_view
			sub / <= codex_server_memory \
	Sessions_restart $mol_button_minor
		title \Перезапустить Codex
		click? <=> codex_server_restart? null
	Prompt $shm_projects_codex_prompt
		hint \Сообщение
		value? <=> prompt?
		event *
			^
			paste? <=> attachment_paste?
		submit? <=> steer?
		enter_submit? <=> send?

$shm_projects_codex $shm_projects_catalog
	Codex $shm_projects_codex_chat
